import React, { isValidElement } from 'react';
import classnames from 'classnames';

import { sanitizeFragments } from '../../utilities/components';

import './WpFormLayout.scss';

type spacing = 'sm' | 'md' | 'lg';
const DEFAULT_SPACING = 'lg';

type direction = 'horizontal' | 'vertical';
const DEFAULT_DIRECTION = 'vertical';

interface Props {
  children?: React.ReactNode;
  direction?: direction;
  spacing?: spacing;
}

const WpFormLayout = ({ children, direction = DEFAULT_DIRECTION, spacing = DEFAULT_SPACING }: Props) => {
  const sanitizedChildren = children && sanitizeFragments(children);

  const baseClassName = 'WpFormLayout';
  const classes = classnames(baseClassName, `${baseClassName}--${direction}`);
  return (
    <div className={classes}>
      {React.Children.map(sanitizedChildren, (child: React.ReactElement<any>) => {
        if (isValidElement(child)) {
          return <div className={`WpFormLayout__item WpFormLayout__item--spacing-${spacing}`}>{child}</div>;
        } else {
          return null;
        }
      })}
    </div>
  );
};

export default WpFormLayout;
